export const HERO_CONSTANTS = {
  button: {
    label: "Build, test, and validate IT solutions today",
    link: "#contact-us",
  },
  title: "Test & Develop IT Solutions in Cloud-Based Physical Labs",
};
